import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import {useEffect} from "react";

const Login = () => {
    const { login, isAuthenticated } = useAuth();

    useEffect(() => {
        localStorage.getItem('activeTab') && localStorage.removeItem('activeTab');
        localStorage.getItem('expandedClients') && localStorage.removeItem('expandedClients');
        localStorage.getItem('expandedBUs') && localStorage.removeItem('expandedBUs');
    },[])

    return isAuthenticated ? <Navigate to="/dashboard" />
        :
        <div className="min-h-screen flex flex-col justify-center">
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
                <h2 className="text-center text-3xl font-extrabold text-gray-900">
                    Team Dashboard
                </h2>
                <p className="mt-2 text-center text-sm text-gray-600">
                    Sign in to access your team's performance metrics
                </p>
                <button
                    className="mt-8 w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#800000]"
                    onClick={login}
                >
                    Sign in using SSO
                </button>
            </div>
        </div>
};

export default Login;